<template>
  <svg width="42" height="42" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <defs>
      <filter x="-30%" y="-23.3%" width="160%" height="160%" filterUnits="objectBoundingBox" id="a">
        <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="shadowSpreadOuter1" />
        <feOffset dy="2" in="shadowSpreadOuter1" result="shadowOffsetOuter1" />
        <feGaussianBlur stdDeviation="2" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
        <feComposite in="shadowBlurOuter1" in2="SourceAlpha" operator="out" result="shadowBlurOuter1" />
        <feColorMatrix
          values="0 0 0 0 0.356862745 0 0 0 0 0.356862745 0 0 0 0 0.356862745 0 0 0 0.25 0"
          in="shadowBlurOuter1"
        />
      </filter>
      <circle id="b" cx="15" cy="15" r="15" />
    </defs>
    <g fill="none" fill-rule="evenodd">
      <g transform="translate(6 4)">
        <use fill="#000" filter="url(#a)" xlink:href="#b" />
        <circle stroke="#FFF" stroke-width="2" fill="#9F8054" cx="15" cy="15" r="16" />
      </g>
      <path
        d="M20.193 9.901v13.652a.901.901 0 1 1-1.802 0v-1.248a.406.406 0 0 0-.45-.412C14.434 22.22 13 23.059 13 24.003c0 1.245 3.116 2.254 8.095 2.254 4.978 0 8.095-1.009 8.095-2.253.001-1.12-2.36-2.064-6.743-2.23a.47.47 0 0 1-.45-.464v-4.053c0-.273.162-.52.414-.628l5.35-2.293c.73-.311.73-1.347 0-1.658l-5.433-2.328a.506.506 0 0 1-.332-.449.901.901 0 1 0-1.803 0Z"
        fill="#FFF"
        fill-rule="nonzero"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'IconPoiGolf',
};
</script>

<style></style>
